<template>
	<!-- <section class="hero-branding bg-cover col-lg-12 bg-img" id="home">
		<div class="container-fluid container-fluid--cp-150 mobile-px-0">
			<div class="hero-branding responsive-hero-branding">
				<div class="w-full">
					<div class="col-lg-8">
						<h1 class="h1 main-title text-center text-md-left">{{ $t('homePage.mainTitle') }}</h1>
						<p class="h5 hero-content-subtitle mt-20 text-center text-md-left">{{ $t('homePage.mainText') }}</p>
						<div class="d-md-none w-full d-flex justify-content-center">
							<img src="../assets/img/3d/3d-printer-main.png" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50 mobile-img" width="514.141px" height="440.219px">
						</div>
						<div class="slider-button mt-30 text-center text-md-left">
							<router-link :to="$t('links.contactUs')" class="ht-btn ht-btn-md">{{ $t('general.getQuoteBtn') }}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section> -->

	<section id="home" style="width:100%;padding:100px 0 40px 0; min-height: 100vh;display:flex;align-items:center;">
		<div style="max-width:1500px;margin:0 auto;display:flex;flex-wrap:wrap;align-items:center;">
			<div style="flex:1 1 400px;min-width:300px;padding:20px 30px 20px 20px;">
			<h1 class="h1 main-title text-center text-lg-left" style="margin-bottom:20px;line-height:1.2;">
				{{ $t('homePage.mainTitle') }}
			</h1>
			<p class="h5 hero-content-subtitle mt-20 text-center text-lg-left" style="font-size:1.25rem;margin-bottom:32px;line-height:1.5;">
				{{ $t('homePage.mainText') }}
			</p>
			<div class="slider-button mt-30 text-center text-lg-left">
				<router-link :to="$t('links.contactUs')" class="ht-btn ht-btn-md">
				{{ $t('general.getQuoteBtn') }}
				</router-link>
			</div>
			</div>
			<div style="flex:1 1 350px;min-width:260px;display:flex;justify-content:center;align-items:center;padding:20px;">
			<img src="../assets/img/3d/510-hero.png" alt="3D Printer"
				style="width:100%;max-width:700px;height:auto;border-radius:8px" />
			</div>
		</div>
	</section>

</template>

<script>
	export default {
		data() {
			return {
				bgImg: {
					backgroundImage: `url(${require('../assets/img/3d/3d-printer-main.png')})`,
				},
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../assets/scss/variabls.scss';
	@import '../assets/scss/elements/hero-branding.scss';

	.bg-img {
		background-repeat: no-repeat;
	}

	@media (max-width: 768px) {
		.bg-img {
			background-image: none !important;
		}

		.hero-branding{
			height:auto !important;
			padding-bottom:20px;
		}
	}

	.mobile-img{
		margin-bottom: -20px;
		margin-top: -10px;
		max-height: 340px;
		width: auto;
	}
</style>